import { SubText, TitleH2 } from 'components/Common/Typography'
import React, { FC } from 'react'
import { Button, Col, Container, Nav, Row, Tab } from 'react-bootstrap'

const OurDevelopmentSecond: FC<{ data; setContactPopup }> = ({
  data,
  setContactPopup,
}) => {
  return (
    <section className="ecommerce-development-second  pt-120px pb-120px">
      <Container>
        <Row className="text-left mb-5">
          <Col xl={5}>
            <TitleH2
              text={data?.title}
              className="mb-3 mb-md-4 text_black"
            />
            <SubText
              className="mb-3 pt-2 pe-0 pe-xl-5 me-0 me-lg-5"
              text={data?.text}
            />
          </Col>
          <Col xl={6} className="text-md-end">
            {/* <Link href="/contact-us"> */}
            {/* <a className="text-decoration-none"> */}
            {/* <Button onClick={() => setContactPopup(true)} className="btn-black">
              <span>Connect</span>
              <span>With Us</span>
            </Button> */}
            {/* </a> */}
            {/* </Link> */}
          </Col>
        </Row>
      </Container>
      <div className="position-relative mt-5">
        <Container>
          <Row className="">
            <Col xs={12}>
              <Tab.Container id="left-tabs-example" defaultActiveKey="tab1">
                <Row className="align-items-stretch justify-content-end">
                  <Col md={4} className="px-md-0 mb-4 mb-md-0">
                    <Nav className="flex-column box-tab-menu">
                      {data?.boxTab?.map((conVal, i) => {
                        return (
                          <React.Fragment key={i}>
                            <Nav.Item className="tab_item">
                              <Nav.Link
                                key={i}
                                eventKey={`tab${i + 1}`}
                                className="cursor-pointer"
                              >
                                <span>{conVal.tabTitle}</span>
                              </Nav.Link>
                            </Nav.Item>
                          </React.Fragment>
                        )
                      })}
                    </Nav>
                  </Col>
                  <Col md={8} className="px-md-0">
                    <Tab.Content className="bg_black">
                      {data?.boxTab?.map((conVal, i) => {
                        return (
                          <React.Fragment key={i}>
                            <Tab.Pane eventKey={`tab${i + 1}`}>
                              <div className="d-flex">
                                <div className="content_col col-md-12">
                                  <h2 className="title_sm mb-3">
                                    {conVal.tabTitle}
                                  </h2>
                                  <p className="mb-5 text_para text-light">
                                    {conVal.tabContent}
                                  </p>
                                  <ul>
                                    {conVal?.tabList?.map((liname, index) => (
                                      <li key={index}>{liname}</li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </Tab.Pane>
                          </React.Fragment>
                        )
                      })}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}

export default OurDevelopmentSecond
